import Styled from "styled-components";

export const Button  = Styled.button`
	border-radius:11px;
	cursor:pointer;
	color:#ffffff;
	font-size:18px;
	padding:8px 18px;
	border:none;
`;

export const Input = Styled.input`
    border:none;
 &:focus{
    outline: none;
 }
    `;